import React, { useEffect, useState } from "react";
import {
    Card,
    CardBody,
    CardHeader,
    CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import Table, {
    dateFormatter,
    buttonsStyle,
} from "../../../components/tables/table";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { alertError, alertSuccess } from "../../../../utils/logger";
import { useHistory } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { getPartners, deletePartner, swapOrdersPartner } from "../../../../api/partner";
import { ArrowUpward, ArrowDownward } from "@material-ui/icons";

export default function PartnersPage() {
    const history = useHistory();
    const user = useSelector((store) => store.authentication?.user, shallowEqual);

    const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
    const [refresh, setRefresh] = useState(false);
    const [data, setData] = useState([]);
    const [partner, setPartner] = useState(null);

    const [tableKey, setTableKey] = useState(0);


    function buttonFormatter(cell) {
        const currentIndex = data.findIndex((item) => item.order === cell);
        const prevId = currentIndex > 0 ? data[currentIndex - 1].order : null;
        const nextId = currentIndex < data.length - 1 ? data[currentIndex + 1].order : null;

        const elem = data.find((item) => item.order === cell);
        const elemPrev = data.find((item) => item.order === prevId);
        const elemNext = data.find((item) => item.order === nextId);
        return (
            <>
                <Tooltip title="Edit">
                    <Button
                        style={buttonsStyle}
                        size="small"
                        onClick={() => history.push("/edit-partner/" + elem._id)}
                    >
                        <EditIcon />
                    </Button>
                </Tooltip>
                {user?.role === "admin" && (
                    <>
                        <Tooltip title="Delete">
                            <Button
                                style={buttonsStyle}
                                size="small"
                                onClick={() => {
                                    setPartner(elem);
                                    setOpenConfirmDialog(2);
                                }}
                            >
                                <DeleteIcon />
                            </Button>
                        </Tooltip>
                    </>
                )}
                {prevId !== null && prevId !== undefined && (
                    <Tooltip title="Move Up">
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => {
                                swapOrdersPartner(elem._id, elemPrev._id).then((res) => {
                                    const changedData = [...data];

                                    const from = data.findIndex((item) => item._id === elem._id);
                                    const to = data.findIndex((item) => item._id === elemPrev._id);
                                    const temp = changedData[from];
                                    changedData[from] = changedData[to];
                                    changedData[to] = temp;

                                    setData(changedData);
                                    setTableKey(k => k + 1);
                                });
                            }}
                        >
                            <ArrowUpward />
                        </Button>
                    </Tooltip>
                )}
                {nextId !== null && nextId !== undefined && (
                    <Tooltip title="Move Down">
                        <Button
                            style={buttonsStyle}
                            size="small"
                            onClick={() => {
                                swapOrdersPartner(elem._id, elemNext._id).then((res) => {
                                    const changedData = [...data];
                                    const from = data.findIndex((item) => item._id === elem._id);
                                    const to = data.findIndex((item) => item._id === elemNext._id);
                                    const temp = changedData[from];
                                    changedData[from] = changedData[to];
                                    changedData[to] = temp;
                                    setData(changedData);
                                    setTableKey(k => k + 1);
                                });
                            }}
                        >
                            <ArrowDownward />
                        </Button>
                    </Tooltip>
                )}
            </>
        );
    }

    const columns = [
        { dataField: "fullName", text: "Name", sort: true },
        {
            dataField: "createdAt",
            text: "Fecha de creación",
            formatter: dateFormatter,
            sort: true,
        },
        {
            dataField: "order",
            text: "",
            formatter: buttonFormatter
        },
    ];

    useEffect(() => {
        getPartners()
            .then((res) => {
                setData(res.data);
            })
            .catch((error) => {
                alertError({ error: error, customMessage: "Could not get partners" });
            });
    }, [refresh]);

    return (
        <>
            <Card>
                <CardHeader title="Partners list">
                    <CardHeaderToolbar>
                        <button
                            type="button"
                            className="btn btn-primary text-white"
                            onClick={() => history.push("/edit-partner")}
                        >
                            Add new
                        </button>
                    </CardHeaderToolbar>
                </CardHeader>
                <CardBody>
                    <Table search={true} data={data} columns={columns} key={tableKey} />


                    <ConfirmDialog
                        title={"Are you sure you want to delete this partner?"}
                        open={openConfirmDialog === 2}
                        setOpen={setOpenConfirmDialog}
                        onConfirm={() => {
                            deletePartner(partner._id)
                                .then((res) => {
                                    alertSuccess({
                                        title: "Deleted!",
                                        customMessage: "Partner deleted successfully.",
                                    });
                                    setRefresh(true);
                                })
                                .catch((error) => {
                                    alertError({
                                        error: error,
                                        customMessage: "Could not delete the partner.",
                                    });
                                });
                        }}
                    />
                </CardBody>
            </Card>
        </>
    );
}
